import toast from "react-hot-toast";
import { normalizeApiError } from "./apiError";

const CODE_MESSAGES = Object.freeze({
  PERMISSION_DENIED: "Je hebt onvoldoende rechten voor deze actie.",
  MFA_SETUP_REQUIRED: "Rond eerst de MFA-configuratie af.",
  MFA_VERIFICATION_REQUIRED: "Verifieer opnieuw met MFA om verder te gaan.",
  VALIDATION_ERROR: "Controleer de ingevulde gegevens en probeer opnieuw.",
  INVALID_GEOJSON: "De contour of brongeometrie is ongeldig.",
  RESOURCE_IN_USE: "Deze wijziging kan nog niet worden uitgevoerd omdat de resource in gebruik is.",
  ACTIVE_CONNECTIONS_PRESENT: "Verwijder of archiveer eerst de actieve verbindingen van deze asset.",
  ACTIVE_CIRCUITS_PRESENT: "Archiveer of verplaats eerst de actieve groepen van deze verdeelkast.",
  CAPACITY_EXCEEDED: "De opgegeven groep overschrijdt de kastcapaciteit.",
  CIRCUIT_POSITION_OVERLAP: "De gekozen groepspositie overlapt met een bestaande groep.",
  EXTERNAL_SOURCE_UNAVAILABLE: "De BAG/PDOK-bron is tijdelijk niet beschikbaar. Bestaande gegevens blijven behouden.",
});

function getRoleNames(user) {
  const values = new Set();

  for (const value of [user?.rol, user?.role]) {
    const normalized = String(value || "").trim().toLowerCase();
    if (normalized) values.add(normalized);
  }

  for (const role of Array.isArray(user?.roles) ? user.roles : []) {
    if (!role) continue;
    if (typeof role === "string") {
      const normalized = role.trim().toLowerCase();
      if (normalized) values.add(normalized);
      continue;
    }
    const normalized = String(role?.name || role?.naam || "").trim().toLowerCase();
    if (normalized) values.add(normalized);
  }

  return Array.from(values);
}

function resolveMfaSetupPath(user) {
  return "/mfa/setup";
}

function resolveCodeMessage(normalized, fallbackMessage) {
  const code = String(normalized?.code || "").trim().toUpperCase();
  if (code === "ACTIVE_CONNECTIONS_PRESENT") {
    const count = Number(normalized?.details?.activeConnectionCount || 0);
    return count > 0
      ? `Deze asset heeft nog ${count} actieve verbinding${count === 1 ? "" : "en"}.`
      : CODE_MESSAGES[code];
  }

  if (code === "ACTIVE_CIRCUITS_PRESENT") {
    const count = Number(normalized?.details?.activeCircuitCount || 0);
    return count > 0
      ? `Deze verdeelkast heeft nog ${count} actieve groep${count === 1 ? "" : "en"}.`
      : CODE_MESSAGES[code];
  }

  return CODE_MESSAGES[code] || normalized?.message || fallbackMessage;
}

export function handleTechnicalAssetApiError(
  error,
  {
    user,
    fallbackMessage = "Actie mislukt",
    onMfaVerificationRequired,
    onMfaSetupRequired,
  } = {}
) {
  const normalized = normalizeApiError(error, fallbackMessage);
  const message = resolveCodeMessage(normalized, fallbackMessage);
  toast.error(message);

  if (normalized.code === "MFA_SETUP_REQUIRED") {
    if (typeof onMfaSetupRequired === "function") {
      onMfaSetupRequired(normalized);
    } else if (typeof window !== "undefined") {
      window.location.href = resolveMfaSetupPath(user);
    }
  }

  if (normalized.code === "MFA_VERIFICATION_REQUIRED") {
    if (typeof onMfaVerificationRequired === "function") {
      onMfaVerificationRequired(normalized);
    } else if (typeof window !== "undefined") {
      window.dispatchEvent(
        new CustomEvent("logboek24:mfa-verification-required", {
          detail: normalized,
        })
      );
    }
  }

  return {
    ...normalized,
    message,
  };
}
